import React from "react";
import type { ApiMeasure } from "@src/api/dictionaries/measures";
import { InputUnit } from "@shared/ui/input";

/**
 * Собирает `endDecorator` с единицей измерения для полей количества. \
 * При отсутствии `ShortName` возвращает `undefined` (adornment не рендерится).
 *
 * @param measure единица измерения или `null`/`undefined`
 * @returns {@link InputUnit} с кратким обозначением либо `undefined`
 *
 * @example
 * ```tsx
 * <Input
 *   label="Выдано"
 *   endDecorator={measureEndDecorator(measure)}
 *   {...form.field("leaveQty").getInputProps()}
 * />
 * ```
 */
export function measureEndDecorator(measure?: ApiMeasure | null): React.ReactNode | undefined {
    const shortName = measure?.ShortName;
    if (shortName == null || shortName.trim() === "") {
        return undefined;
    }
    return <InputUnit>{shortName}</InputUnit>;
}
